import React, { Component } from "react";
import { GetData } from "../../../api/service";
import {
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
} from "@material-ui/core";
import Edit from "@material-ui/icons/Edit";

export default class IqacFileGroupLanding extends Component {
  state = {
    list: [],
    isLoaded: false,
  };

  componentDidMount() {
    GetData(`/${this.props.apikey}/getiqacfilegroup`).then((resp) => {
      this.setState({
        list: resp,
        isLoaded: true,
      });
    });
  }

  render() {
    return (
      <div>
        <Typography variant="h6">IQAC File Group</Typography>

        <div align="right">
          <Button
            variant="contained"
            color="primary"
            onClick={() => this.props.history.push("/filegroup/add")}
          >
            Add File Group
          </Button>
        </div>
        <br />
        <Table size="small" style={{ backgroundColor: "#fff" }}>
          <TableHead>
            <TableRow>
              <TableCell width="5%">#</TableCell>
              <TableCell width="15%">Group Name</TableCell>
              <TableCell width="65%">Order</TableCell>
              <TableCell width="5%">Edit</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.list.map((el, index) => (
              <TableRow key={index} style={{ verticalAlign: "top" }}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{el.group_name}</TableCell>
                <TableCell>{el.index1}</TableCell>
                <TableCell>
                  <Edit
                    onClick={() =>
                      this.props.history.push("/filegroup/edit", el)
                    }
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Iqac/Facility/IqacFileGroupLanding.js